import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'
import { GET_ONE_CRASH_COURSE, UPDATE_CRASH_COURSE } from 'queries/crashCourse'
import { updateCrashCourse, updateCrashCourseVariables } from '__generatedTypes__/updateCrashCourse'
import { findOneCrashCourse, findOneCrashCourseVariables } from '__generatedTypes__/findOneCrashCourse'
import { CreateCrashCourseInput } from '__generatedTypes__/globalTypes'
import { PageLoader } from 'components/PageLoader'
import { toast } from 'utils/toast'
import { Form } from '../Form'

export const Edit = () => {
  const { crashCourseId = '' } = useParams()
  const { navigate } = useLink()
  const [update] = useMutation<updateCrashCourse, updateCrashCourseVariables>(UPDATE_CRASH_COURSE)
  const { data, loading } = useQuery<findOneCrashCourse, findOneCrashCourseVariables>(GET_ONE_CRASH_COURSE, {
    variables: {
      params: crashCourseId,
    },
    fetchPolicy: 'network-only',
  })
  const crashCourse = data?.findOneCrashCourse

  const handleSubmit = useCallback(
    async (crashCourse: CreateCrashCourseInput) => {
      try {
        const { data } = await update({
          variables: {
            params: {
              id: crashCourseId,
              ...crashCourse,
            },
          },
        })

        if (data?.updateCrashCourse.id) {
          navigate(cmsRoutes.CRASH_COURSE_LIST, undefined, {
            searchParams: new URLSearchParams({ subjectId: String(crashCourse.subject?.id) }),
          })
        }
        toast.success('Crash course updated successfully')
      } catch (error) {
        toast.error('Failed to update crash course')
      }
    },
    [crashCourseId, update, navigate]
  )

  useEffect(() => {
    if (!loading && !crashCourse) {
      navigate(cmsRoutes.CRASH_COURSE_LIST)
      toast.error('Crash course not found, redirecting to crash course list')
    }
  }, [loading, crashCourse])

  if (loading || !crashCourse) {
    return <PageLoader />
  }

  return <Form crashCourseOrSubjectId={crashCourse} onSubmit={handleSubmit} />
}
